import React from 'react';
import { usePermission } from '../hooks/usePermission';

interface MenuGuardProps {
  slug: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * MenuGuard
 * Controla a renderização de itens de menu baseado no RBAC dinâmico da empresa/cargo.
 * Se o menu estiver habilitado para o perfil na empresa atual, renderiza os filhos;
 * caso contrário, oculta (ou exibe fallback opcional).
 */
export const MenuGuard: React.FC<MenuGuardProps> = ({ slug, children, fallback = null }) => {
  const { menuVisivel, isAdmin } = usePermission();

  // Salvaguarda: Administrador sempre visualiza o controle de menus
  if (slug === 'controle-menus' && isAdmin) {
    return <>{children}</>;
  }

  if (menuVisivel(slug)) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};

export default MenuGuard;
